import { NotFoundPage } from "@ancatag/at-design";
import { FileQuestion } from "lucide-react";
import { useLocation } from "wouter";
import { useAuth } from "../context/AuthContext";

export function NotFound() {
	const [, setLocation] = useLocation();
	const { isAuthenticated } = useAuth();

	const handleHomeClick = () => {
		if (isAuthenticated) {
			setLocation("/dashboard");
		} else {
			setLocation("/");
		}
	};

	return (
		<div className="min-h-screen w-full bg-background">
			<NotFoundPage
				showHomeButton
				showBackButton
				onHomeClick={handleHomeClick}
				homeButtonLabel={isAuthenticated ? "Go to Dashboard" : "Go Home"}
				variant="full"
				icon={FileQuestion}
				description="The page you're looking for doesn't exist or has been moved. It might have been deleted, renamed, or the URL might be incorrect."
			/>
		</div>
	);
}
